var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useMemo, useState } from 'react';
import { Add, DragIndicator, RemoveCircleOutlineOutlined } from '@material-ui/icons';
import { useFormContext } from '../FormContext';
import { IconButton } from '@material-ui/core';
import { ConfigListItem } from './components/ConfigList';
import styled from 'styled-components';
import { Alert } from '@material-ui/lab';
import FormConfigTransitionConditionDialog from '../dialogs/FormConfigTransitionConditionDialog';
import StateNodeSelect from '../state-node/StateNodeSelect';
const StyledConfigListItem = styled(ConfigListItem) `
  .state-node-select {
    &:hover {
      background: #f4f4f4;
    }
    .MuiAutocomplete-inputRoot[class*='MuiInput-root'][class*='MuiInput-marginDense']
      .MuiAutocomplete-input:first-child {
      font-size: 13px;
      padding-top: 6px;
    }
  }
  code {
    font-size: 13px;
    background: #f4f5fa;
    padding: 2px 4px;
    border-radius: 3px;
    margin-right: 5px;
  }
  .when {
    align-self: flex-start;
  }
`;
const StyledConditionList = styled.ul `
  padding-left: 22px;
  list-style: none;
  .condition {
    display: flex;
    .plugin-display {
      flex: 1;
      overflow: auto;
      cursor: pointer;
      &:hover {
        background: #f4f4f4;
      }
    }
    .delete {
      margin-right: 4px;
    }
    &.add {
      code {
        margin-top: 2px;
        display: flex;
        align-items: center;
        cursor: pointer;
        &:hover {
          background: #e4e4e4;
        }
      }
      .add-icon {
        width: 12px;
        height: 12px;
        color: rgba(0, 0, 0, 0.87);
        margin-right: 4px;
      }
    }
  }
`;
export const FormConfigEventTransition = forwardRef((_a, ref) => {
    var _b;
    var { event, transition, className, dragHandleProps, onChangeTarget, onDelete } = _a, props = __rest(_a, ["event", "transition", "className", "dragHandleProps", "onChangeTarget", "onDelete"]);
    const { trackChanges, transitionConditionPlugins, addTransitionCondition, updateTransitionCondition, moveTransitionCondition, deleteTransitionCondition } = useFormContext();
    const [editCondition, setEditCondition] = useState();
    const target = useMemo(() => {
        var _a, _b, _c;
        return ((_c = (_b = (_a = trackChanges.final.states) === null || _a === void 0 ? void 0 : _a.find(stateNode => stateNode.name === (transition === null || transition === void 0 ? void 0 : transition.target))) === null || _b === void 0 ? void 0 : _b.meta) === null || _c === void 0 ? void 0 : _c.title) || transition.target;
    }, [trackChanges.final.states, transition.target]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledConfigListItem, Object.assign({ ref: ref, className: className, icon: React.createElement(DragIndicator, null), iconProps: dragHandleProps, primary: React.createElement(React.Fragment, null,
                React.createElement("code", null, "TO:"),
                React.createElement(StateNodeSelect, { stateNodeConfig: trackChanges.final, getOptionLabel: (path, pathMap) => { var _a, _b; return ((_b = (_a = pathMap.get(path)) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.title) || path; }, value: target || '', onChange: target => onChangeTarget === null || onChangeTarget === void 0 ? void 0 : onChangeTarget(target) })), secondaryAction: React.createElement(IconButton, { size: 'small', onClick: e => {
                    e.stopPropagation();
                    onDelete === null || onDelete === void 0 ? void 0 : onDelete(transition);
                } },
                React.createElement(RemoveCircleOutlineOutlined, null)) }, props),
            React.createElement(StyledConditionList, { className: 'condition-list' }, (_b = transition.conditions) === null || _b === void 0 ? void 0 :
                _b.map((condition, index) => {
                    const plugin = transitionConditionPlugins.find(plugin => plugin.type === condition.type);
                    if (!plugin) {
                        return (React.createElement(Alert, { severity: 'error' },
                            "Condition \"",
                            condition.type,
                            "\" plugin not found."));
                    }
                    return (React.createElement("li", { className: 'condition', key: index },
                        React.createElement("code", { className: 'when' },
                            index === 0 ? 'IF' : 'AND',
                            ":"),
                        React.createElement("div", { className: 'plugin-display', onClick: () => {
                                setEditCondition(condition);
                            } },
                            React.createElement(plugin.display, { condition: condition })),
                        React.createElement("div", { className: 'delete' },
                            React.createElement(IconButton, { size: 'small', onClick: () => deleteTransitionCondition(event, transition, index) },
                                React.createElement(RemoveCircleOutlineOutlined, null)))));
                }),
                React.createElement("li", { className: 'condition add' },
                    React.createElement("code", { className: 'when', onClick: () => setEditCondition(null) },
                        React.createElement(Add, { className: 'add-icon' }),
                        " Add Condition")))),
        (editCondition || editCondition === null) && (React.createElement(FormConfigTransitionConditionDialog, { condition: editCondition, open: Boolean(editCondition || editCondition === null), onCancel: () => setEditCondition(undefined), onChange: condition => {
                setEditCondition(undefined);
                if (editCondition) {
                    const index = transition.conditions.indexOf(editCondition);
                    updateTransitionCondition(event, transition, index, condition);
                }
                else {
                    addTransitionCondition(event, transition, condition);
                }
            } }))));
});
export default FormConfigEventTransition;
//# sourceMappingURL=FormConfigEventTransition.js.map